export enum CanonicalsWorkspaceCapabilityAccessOperation {
    create = "3367c437-5a16-4fdc-8adf-a616a48db381",
    read = "1ba3d994-91fc-467b-a273-27274448d20b",
    update = "324a5e12-42a2-44e5-9102-1b7d57545da8",
    delete = "462ab53b-08e8-4be3-be9c-81df2f35dba6",
}
